import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, catchHandler } from "../../utils/helpers";

const state = {

};

const getters = {
};

const mutations = {
};

const actions = {
    async getVacations(_, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.reports.getVacations(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getEmployeesJobs(_, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.reports.getEmployeesJobs(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    }, 
    async getBonuses(_, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.reports.getBonuses(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getCorrelator(_, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.reports.getCorrelator(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
     async getRetirement(_, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.reports.getRetirement(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },   
     async getEmployeesJobGrades(_, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.reports.getEmployeesJobGrades(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },    
     async getEmployeesQualifications(_, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.reports.getEmployeesQualifications(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    }, 
     async getEmployeeCourses(_, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.reports.getEmployeeCourses(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
// ------------------------------------ print ----------------
async getBonusStatment(_, id) {
    try {
     
        startLoading()
        const response = await dataService.reports.getBonusStatment(id);
        stopLoading()

        if (!response.data.statusCode) {
            showAlert(serverErrorMessage);
            return;
        }

        return Promise.resolve(response.data);

    } catch (error) {
        stopLoading()
        catchHandler(error);
    }
},


};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
